import { Calendar } from "../model/Calendar";
import { ReservationDetails, ReservationSummary } from "../model/ReservationDetails";
import { ServiceInfo } from "../model/ServiceInfo";

export class BookingAPI
{
    private base_url: string;

    constructor(agency_id: number) {
        this.base_url = 'https://rezerwuj.thesoft.pl/api/v1/agencies/' + agency_id;
    }

    async getServices() {
        let url = `${this.base_url}/services/`;

        let response = await fetch(url);
        let json = await response.json();

        return json as ServiceInfo[];
    }

    async getCalendar(service_id: number, year: number, month: number) {
        let url = `${this.base_url}/calendar/${year}/${month}/?service_id=${service_id}`;

        let response = await fetch(url);
        let json = await response.json();

        return json as Calendar;
    }

    async reserve(reservation: ReservationDetails) {
        let url = `${this.base_url}/reservations/`;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(reservation)
        };

        let response = await fetch(url, requestOptions);
        let json = await response.json();

        return json as ReservationSummary;
    }

    static get() {
        return new BookingAPI(1);
    }
}